import React from "react";
import { Box, Typography, Card, CardContent, Chip, Button } from "@mui/material";
import { PlayArrow as DemoIcon, School as SchoolIcon } from "@mui/icons-material";
import { motion } from "framer-motion";
import Schools from "./Schools";

const DemoSchools = () => {
  return (
    <Box>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
      >
        <Box sx={{ mb: 3, display: "flex", alignItems: "center", gap: 2 }}>
          <DemoIcon sx={{ fontSize: 40, color: "info.main" }} />
          <Box>
            <Typography variant="h4" sx={{ fontWeight: 700 }}>
              Demo Schools
            </Typography>
            <Typography variant="body1" sx={{ color: "text.secondary" }}>
              Schools currently in trial/demo period
            </Typography>
          </Box>
        </Box>
        <Card sx={{ mb: 3, bgcolor: "info.light", color: "info.contrastText" }}>
          <CardContent>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <Box>
                <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
                  Convert Demo to Paid
                </Typography>
                <Typography variant="body2">
                  Track and convert demo schools to paid subscriptions. Focus on high-value prospects.
                </Typography>
              </Box>
              <Button variant="contained" color="info" sx={{ bgcolor: "white", color: "info.main", "&:hover": { bgcolor: "grey.100" } }}>
                View Conversion Analytics
              </Button>
            </Box>
          </CardContent>
        </Card>
        {/* This would be a filtered view of Schools component */}
        <Typography variant="body1" sx={{ color: "text.secondary", textAlign: "center", py: 4 }}>
          Demo schools list - Filtered view of Schools component
        </Typography>
      </motion.div>
    </Box>
  );
};

export default DemoSchools;

